import React from 'react';
import {Button, Col, Container, Row} from 'reactstrap';
import {Link} from 'react-router-dom';
import {ContentTable} from 'components/Contents';
import {removePrefix} from 'utils/string';
import {MDB_PREFIX} from 'configs';

class PublicCertifications extends React.Component {
  render() {
    const {items, meta, isLoading} = this.props;

    return (
      <ContentTable meta={meta} pagination isFetching={isLoading} head={[]}>
        <Container className="d-flex flex-wrap px-0">
          <Row>
            {items.map((item, index) => {
              const {
                // type,
                mdbcert_id,
                cert_number,
                ab_id,
                ab_name,
                cb_id,
                cb_name,
                cert_st_sch,
              } = item;
              const mdbCertId = removePrefix(mdbcert_id, MDB_PREFIX.cert);

              return (
                <Col
                  key={index}
                  lg={items.length > 1 ? 6 : 12}
                  className="mb-5"
                >
                  <Row tag="dl" className="mb-3">
                    <Col tag="dt" lg="4">
                      Certificate Number:
                    </Col>
                    <Col tag="dd" lg="8" className="text-truncate">
                      {cert_number}
                    </Col>

                    <Col tag="dt" lg="4">
                      Standard(s):
                    </Col>

                    <Col tag="dd" lg="8">
                      <ul
                        style={{
                          margin: 0,
                        }}
                      >
                        {cert_st_sch.map((items, idx) => {
                          const {st_name} = items;

                          return (
                            <li
                              key={idx}
                              style={{margin: 0}}
                              className="text-truncate"
                            >
                              {st_name}
                            </li>
                          );
                        })}
                      </ul>
                    </Col>

                    <Col tag="dt" lg="4">
                      Accreditation Body:
                    </Col>

                    <Col tag="dd" lg="8" className="text-truncate">
                      <Link to={`/accreditation-body/${ab_id}`}>{ab_name}</Link>
                    </Col>
                    <Col tag="dt" lg="4">
                      Certification Body:
                    </Col>
                    <Col tag="dd" lg="8" className="text-truncate">
                      <Link to={`/certification-body/${cb_id}`}>{cb_name}</Link>
                    </Col>
                  </Row>

                  <Button
                    tag={Link}
                    color="primary"
                    to={`/certification/${mdbCertId}`}
                  >
                    View Certificate Information
                  </Button>
                </Col>
              );
            })}
          </Row>
        </Container>
      </ContentTable>
    );
  }
}

export default PublicCertifications;
